import { useState, useEffect } from 'react';
import { Game } from '../types';
import { fetchTodaysGames } from '../lib/api';
import { scoreGame } from '../lib/scoring';
import { MOCK_GAMES } from '../data/mockData';

interface UseGamesResult {
  games: Game[];
  loading: boolean;
  error: string | null;
  isLive: boolean;
}

export function useGames(): UseGamesResult {
  const [games, setGames] = useState<Game[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [isLive, setIsLive] = useState(false);

  useEffect(() => {
    async function loadGames() {
      try {
        setLoading(true);
        setError(null);

        const inputs = await fetchTodaysGames();

        if (inputs.length === 0) {
          // Fall back to mock data if API returns nothing
          console.warn('No live games found — using mock data');
          setGames(MOCK_GAMES);
          setIsLive(false);
          return;
        }

        // Run each game through the scoring model
        const scored = inputs
          .map(input => scoreGame(input))
          .sort((a, b) => b.prob - a.prob);

        setGames(scored);
        setIsLive(true);

      } catch (err) {
        console.error('useGames error:', err);
        // Fall back to mock data on any error
        setGames(MOCK_GAMES);
        setIsLive(false);
        setError('Using demo data — live data temporarily unavailable');
      } finally {
        setLoading(false);
      }
    }

    loadGames();
  }, []);

  return { games, loading, error, isLive };
}
